/**
 * 结算账户状态
 */
export enum SettleAccountStatus {
    Default = '',
    Submitting = 0, // 待提交纸质资料
    Processing = 1, // 资料审核中
    Agree = 2, // 审核通过
    Reject = 3, // 审核拒绝
}
